<template>

    <vx-card id="openConnectionsChart" class="vs-con-loading__container">

        <template slot="actions">

            <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                <small class="flex cursor-pointer">
                    <span>{{metricTimes[timeRange]}}</span>
                    <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                </small>
                <vs-dropdown-menu class="w-48">
                    <vs-dropdown-item @click="timeRange = 1">Last day</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 7">Last 7 days</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 14">Last 14 days</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 30">Last 30 days</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 90">Last 90 days</vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>

            <feather-icon icon="RefreshCwIcon" @click="loadData()"></feather-icon>

        </template>

        <vue-apex-charts v-if="chartOptions" type="line" height="400" :options="chartOptions" :series="chartData"/>

    </vx-card>
</template>
<script>

import VueApexCharts from 'vue-apexcharts'

export default {
    props: {
        link: {
            type: String,
            required: true
        }
    },
    components: {
        VueApexCharts
    },
    data(){
        return {

            chartData: [],
            timeRange: 1,

            metricTimes: {
                1: 'Last day',
                7: 'Last 7 days',
                14: 'Last 14 days',
                30: 'Last 30 days',
                90: 'Last 90 days'

            },

            chartOptions: {
                colors: ['#7367F0'],
                xaxis: {
                    type: 'datetime',
                    labels: {
                        datetimeUTC: true
                    }
                },
                yaxis: {
                    min: 0,
                    forceNiceScale: true,
                    labels: {
                        formatter: function(value) {
                            return ((value) ? value : 0)
                        }
                    }
                },
                tooltip: {
                    x: {
                        format: 'dd/MM/yyyy HH:mm'
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'straight',
                    width: 3
                },
                title: {
                    text: 'Total connections open',
                    align: 'left'
                }
            }

        }
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#openConnectionsChart',
                type: 'corners',
                scale: 0.7
            })

            const thisIns = this
            const loadPromise = this.$http.get(this.link + '?days=' + this.timeRange)
            loadPromise.then(function(response) {
                thisIns.chartData = JSON.parse(JSON.stringify(response.data))
            }).catch(function(error) {
                thisIns.$printError(error.response.data)
            }).finally(function() {
                thisIns.$vs.loading.close('#openConnectionsChart > .con-vs-loading')
            })
        }
    },
    watch: {
        timeRange() {
            this.loadData()
        }
    },
    mounted() {
        this.loadData()
    }
}
</script>
